import { CircularProgress } from "@mui/material";
import HoverToolTip from "../../reuseableComponents/HoverToolTip";

const RadioSelect = ({
  item,
  handleOnlineChange,
  handleRegisterChange,
  disableCategories,
  onlineStautusLoaging = false,
  registerStautusLoaging = false,
  categoryId = null,
}) => {
  return (
    <>
      <div className="category-checkmark-div ">
        <HoverToolTip
          title={"Show or hide this category on your online store."}
        >
          {onlineStautusLoaging && categoryId === item.id ? (
            // true
            <div className="flex items-center">
              <CircularProgress
                color={"inherit"}
                // style={{
                //   position: "absolute",
                //   left: "3.5rem",
                // }}
                width={15}
                size={15}
              />
              <label
                style={{ paddingLeft: "18px" }}
                className="category-checkmark-label"
              >
                Online
              </label>
            </div>
          ) : (
            <label
              className="category-checkmark-label"
              style={{
                cursor: +item?.is_lottery === 1 ? "not-allowed" : "pointer",
                opacity: +item?.is_lottery === 1 ? 0.6 : 1,
              }}
            >
              Online
              <input
                type="checkbox"
                checked={
                  +item?.is_lottery === 1
                    ? false
                    : item.cat_show_status === "0" ||
                      item.cat_show_status === "1"
                }
                onChange={() => {
                  if (disableCategories) {
                    handleOnlineChange(item);
                  }
                }}
                disabled={+item?.is_lottery === 1}
              />
              <span className="category-checkmark"></span>
            </label>
          )}
        </HoverToolTip>
        <HoverToolTip title={"Enable this category for in-store sales"}>
          {registerStautusLoaging && categoryId === item.id ? (
            // true
            <div className="flex items-center">
              <CircularProgress
                color={"inherit"}
                // style={{
                //   position: "absolute",
                //   left: "3.5rem",
                // }}
                width={15}
                size={15}
              />
              <label
                style={{ paddingLeft: "18px" }}
                className="category-checkmark-label"
              >
                Register
              </label>
            </div>
          ) : (
            <label className="category-checkmark-label">
              Register
              <input
                type="checkbox"
                checked={
                  item.cat_show_status === "0" || item.cat_show_status === "2"
                }
                onChange={() => {
                  if (disableCategories) {
                    handleRegisterChange(
                      item.id,
                      item.cat_show_status === "0" ||
                        item.cat_show_status === "2"
                        ? "2"
                        : "0",
                      item
                    );
                  }
                }}
              />
              <span className="category-checkmark"></span>
            </label>
          )}
        </HoverToolTip>
      </div>
    </>
  );
};

export default RadioSelect;
